import { IntegrationsActionType } from '@modules/integrationsV2/store/integrationsActionType';
import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';
import { ArrowBackRounded } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';

export const SelectIntegrationTypeDrawerHeader = () => {
  const selectedIntegrationToConnect = useIntegrationsStore(
    ({ view }) => view.selectedIntegrationToConnect,
  );

  const dispatch = useIntegrationsStore(({ dispatch }) => dispatch);

  if (!selectedIntegrationToConnect) {
    return null;
  }

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'divider',
        px: 3,
        py: 2,
      }}
    >
      <Stack direction="row" columnGap={2} alignItems="center">
        <IconButton
          onClick={() => {
            dispatch({
              type: IntegrationsActionType.SET_VIEW,
              payload: {
                selectedIntegrationToConnect: null,
              },
            });
          }}
        >
          <ArrowBackRounded />
        </IconButton>
        <Typography variant="h6">
          How would you like to integrate{' '}
          {selectedIntegrationToConnect.integrationChannel.displayName}?
        </Typography>
      </Stack>
    </Stack>
  );
};
